
export default {
  upsert(state, payload) {
    state.partner = payload;
  },
}
